/* eslint-disable react/prop-types */
import React from "react";
import ReleasesTable from "./ReleasesTable";

export default function InternalControl() {
  return (
    <ReleasesTable
      filterBy="approvals Reviewed"
      approval_status="Final Internal Controls"
      title="Final Internal Controls"
      _approval_status="select_by_status"
      return_status="Approval Initiated Returned"
      showHistoryTab={true}
    />
  );
}
